import React from 'react';
import clsx from 'clsx';
import { CardHorizontalFeature, CardHorizontalFeatureProps, renditions } from '@marriott/mi-ui-library';
import { ProductDetailsCard } from '../../organisms/ProductDetailsCard';
import { ProductDetailsCardProps } from '../../organisms/ProductDetailsCard/ProductDetailsCard.types';
import { DynamicTabPanelProps } from '../../organisms/DynamicTabbedLayout/DynamicTabbedLayout.types';
import { buildDynamicMediaNode } from '../../utils/dynamicMediaUtils';
import { StyledTabPanelGrid, StyledTabPanelItem } from './Tabs.styles';

export const DynamicTabPanel: React.FC<DynamicTabPanelProps> = ({ slots }) => {
  return (
    <StyledTabPanelGrid>
      {(() => {
        let nonBannerIndex = 0;
        return (slots || []).map(slot => {
          const key = `slot-${slot?.position ?? 0}`;
          const size = (slot?.size as 'square' | 'tall' | 'banner') ?? 'square';
          const isBanner = size === 'banner';
          const colClass = isBanner ? '' : `pos-${(nonBannerIndex++ % 3) + 1}`;

          const content = (slot?.payload as Record<string, unknown> | undefined) ?? undefined;
          const contentObj = (content ?? {}) as Record<string, unknown>;
          const baseUrl = (contentObj['assetPath'] as string) || (contentObj['image'] as string) || '';
          const alt = (contentObj['imageAltText'] as string) || '';
          const EMPTY_DynamicMedia: renditions = { altText: '', assetPath: '', dynamic: false, renditions: [] };
          const dynamicMedia = buildDynamicMediaNode(baseUrl, 'square', alt) || EMPTY_DynamicMedia;
          const dynamicMediaWide = buildDynamicMediaNode(baseUrl, 'wide', alt) || EMPTY_DynamicMedia;
          const dynamicMediaTall = buildDynamicMediaNode(baseUrl, 'tall', alt) || EMPTY_DynamicMedia;

          return (
            <StyledTabPanelItem key={key} className={clsx(size, colClass)}>
              {isBanner ? (
                <CardHorizontalFeature
                  {...({
                    ...(contentObj as Record<string, unknown>),
                    header: (contentObj?.['title'] as string) || '',
                    eyebrowtext: (contentObj?.['eyebrow'] as string) || '',
                    dynamicMedia: dynamicMediaWide,
                  } as CardHorizontalFeatureProps)}
                />
              ) : (
                <ProductDetailsCard
                  {...({
                    ...(contentObj as Record<string, unknown>),
                    breakPointKey: 'viewportL',
                    fileReferenceImage: baseUrl,
                    dynamicMedia: dynamicMedia,
                    dynamicMediaWide: dynamicMediaWide,
                    dynamicMediaTall: dynamicMediaTall,
                    cardVariation: size,
                  } as ProductDetailsCardProps)}
                />
              )}
            </StyledTabPanelItem>
          );
        });
      })()}
    </StyledTabPanelGrid>
  );
};
